import { motion } from "framer-motion";
import { WHAT_WE_DONT_PROMISE } from "@/data/content";

export default function HonestyBlock() {
  return (
    <section
      data-testid="honesty-block"
      className="py-20 sm:py-28 lg:py-36 px-5 sm:px-6 lg:px-12"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <p className="overline">{WHAT_WE_DONT_PROMISE.eyebrow}</p>
          <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1] mt-5 sm:mt-6">
            <span className="italic text-aurora">{WHAT_WE_DONT_PROMISE.title}</span>
          </h2>
          <p className="text-neutral-600 text-base sm:text-lg leading-relaxed mt-6 sm:mt-8 max-w-md">
            The fastest way to tell if a partner is worth your time is to
            read what they refuse to promise. Here is ours, in plain text.
          </p>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <ol className="border-t border-neutral-200">
            {WHAT_WE_DONT_PROMISE.items.map((item, i) => (
              <motion.li
                key={item}
                initial={{ opacity: 0, x: 12 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                data-testid={`honesty-item-${i}`}
                className="flex gap-4 sm:gap-6 py-5 sm:py-6 border-b border-neutral-200 text-base sm:text-lg text-neutral-700 leading-relaxed"
              >
                <span className="font-serif italic text-xl sm:text-2xl text-gold leading-none flex-none w-8 sm:w-10">
                  0{i + 1}
                </span>
                <span>{item}</span>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
